import { pinkToBlue } from "@global/colors";
import { styled, Typography } from "@mui/material";

export const StyledText = styled(Typography)({
  background: pinkToBlue(),
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
})